import React, { useState } from "react";
import Selector from "../components/Selector";
import NotesList from "../components/NotesList";
import { useBoards, useClasses, useSubjects, useNotes } from "../hooks/useData";

export default function LearnPage() {
  const [selected, setSelected] = useState({ board: null, class: null, subject: null });

  const { data: boards, loading: boardsLoading } = useBoards();
  const { data: classes, loading: classesLoading } = useClasses(selected.board);
  const { data: subjects, loading: subjectsLoading } = useSubjects(selected.board, selected.class);
  const { data: notes, loading: notesLoading } = useNotes(selected.subject);

  const handleSelect = (type, value) => {
    if (type === "board") setSelected({ board: value, class: null, subject: null });
    else if (type === "class") setSelected((p) => ({ ...p, class: value, subject: null }));
    else setSelected((p) => ({ ...p, subject: value }));
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>Study Material</h1>
        <p style={styles.sub}>Download chapter-wise notes for your board and class</p>
      </div>

      <Selector
        boards={boards}
        classes={classes}
        subjects={subjects}
        selected={selected}
        onSelect={handleSelect}
        loading={boardsLoading || classesLoading || subjectsLoading}
      />

      <NotesList notes={notes} loading={notesLoading} />
    </div>
  );
}

const styles = {
  page: { maxWidth: 900, margin: "0 auto", padding: "40px 24px 80px" },
  header: { marginBottom: 32 },
  title: {
    fontSize: 28, fontWeight: 700,
    color: "#f8fafc",
    fontFamily: "'Sora', sans-serif",
    marginBottom: 6,
  },
  sub: {
    fontSize: 15, color: "#64748b",
    fontFamily: "'Sora', sans-serif",
  },
};
